import styled from "styled-components";

export const Container = styled.div`
    & > :first-child {
        transform: rotate(0);
        transition: transform 1.2s;
    }
`